import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAppSelector } from 'store/storeHooks'

function HomePage() {
  const navigate = useNavigate()
  const { managementOrganizationId } = useAppSelector(
    (state: any) => state.user
  )

  useEffect(() => {
    if (managementOrganizationId) {
      navigate(`/organization/${managementOrganizationId}`)
    }
  }, [navigate, managementOrganizationId])

  return null
}

export default HomePage
